import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { APP_CONFIG, Plan } from '../../../core';
import { BaseComponent } from '../../../shared';
import { PrtTemplateComponent } from '../prt-template';


/**
 * Third page of PDF print.
 */
@Component({
	selector: 'print-page-three',
	templateUrl: './page-three.component.html',
	imports: [
		PrtTemplateComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class PageThreeComponent extends BaseComponent implements OnInit {

	private readonly config = inject(APP_CONFIG);

	@Input() isDemo = false;
	@Input() today: Date | null = null;

	currentCase?: Plan;
	readonly cdnBaseUrl: string = this.config.cdnUrl;


	ngOnInit(): void {
		this.currentCase = this.canvasSrv.currentCase;
	}

}
